<template>
  <!-- 头部整体盒子 -->
  <div class="container1 row-center-center header" :class="headerFixed ? 'fixed' : ''">
    <div style="width: 1200px;height: 97px;box-sizing: border-box;" class="row-between-center">
      <div class="left" @click="goHome()">
        <img src="@/assets/img/logo_jx.png" />
      </div>
      <div class="zhedie-box" @mouseover="showHiddenMenu" @click="showMenu = !showMenu">
        <img src="@/assets/img/zhedie.png" alt="">
      </div>
      <div class="menu_list">
        <ul class="-nav-wrapper row-start-center">
          <li v-for="(item, index) in navList" :key="index" :class="index == navIndex ? 'active' : 'noactive'"
            @click="navClick(index, item.name)">
            <div class="goAddress" @click="goPath(item)" @mouseover="mouseOverNav(index)" @mouseleave="mouseLeave"
              :class="menuIndex == item.path ? 'goAddress-active' : ''">
              {{ item.name }}
              <span v-if="item.children.length > 0" class="glyphicon glyphicon-menu-down"></span>
              <i class="underline"></i>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <!-- 产品与服务 -->
    <!-- <div class="user-mask" v-if="hoverIndex === 2 && showMask">
      <div class="user-login" @mouseleave="showMask = false">
        <div class="user-login-box">
          <el-tabs tab-position="left" v-model="tabsValue1">
            <el-tab-pane v-for="(item, index) in productsAndServices" :key="index">
              <span slot="label" class="row-end-center tab-pane-left"><el-image :src="getImagePath(item.image)" alt=""
                  class="tab-image" fit="scale-down"></el-image> {{ item.level1 }}</span>
              <div class="row-start-start-flex">
                <div v-for="(jitem, j) in item.list1" :key="j" style="width: 33.3%;">
                  <p class="tab-pane-right-title">{{ jitem.level2 }}</p>
                  <p v-for="(kitem, k) in jitem.list2" :key="k"  style="font-size: 14px;cursor: pointer;margin: 10px 0;"
                    @click="goProductsServices(kitem, index = 1)">{{ kitem.title }}</p>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div> -->
    <!-- 解决方案 -->
    <!-- <div class="user-mask" v-else-if="hoverIndex === 3 && showMask">
      <div class="user-login" @mouseleave="showMask = false">
        <div class="user-login-box">
          <el-tabs tab-position="left" v-model="tabsValue2">
            <el-tab-pane :label="item.level1" v-for="(item, index) in solution" :key="index">
              <span slot="label" class="row-end-center tab-pane-left"><el-image :src="getImagePath(item.image)" alt=""
                  class="tab-image" fit="scale-down"></el-image> {{ item.level1 }}</span>
              <div class="row-start-start-flex">
                <div v-for="(jitem, j) in item.list1" :key="j" style="width: 33%;">
                  <p class="tab-pane-right-title">{{ jitem.level2 }}</p>
                  <p v-for="(kitem, k) in jitem.list2" :key="k" style="font-size: 14px;margin: 10px 0;cursor: pointer;"
                    @click="goSolution(kitem, index = 2)">{{ kitem.title }}
                  </p>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div> -->
    <!-- 应用案例 -->
    <!-- <div class="user-mask" v-else-if="hoverIndex === 4 && showMask">
      <div class="user-login row-center-center" @mouseleave="showMask = false">
        <div class="user-login-box row-center-center">
          <div v-for="(item, index) in applicationCases" style="width: 30%;margin: 0 20px;">
            <div class="row-start-center">
              <span><el-image :src="getImagePath(item.image)" alt="" class="tab3-image"
                  fit="scale-down"></el-image></span>
              <p style="font-weight: 600;color:#3E86CA;font-size: 16px;">{{ item.level1 }}</p>

            </div>
            <div v-for="(jitem, j) in item.list" style="cursor: pointer;" @click="goApplicationCase(jitem, index = 3)">
              <p style="font-size: 14px;margin: 10px 0;">{{ jitem.title }}</p>
              <span style="font-size: 12px;color: #999;margin-bottom: 20px;" class="ellipes-line-clamp3">{{ jitem.des
                }}</span>
            </div>
          </div>
        </div>

      </div> 
    </div>-->
    <!-- 用户登录 -->
    <div class="user-mask" v-if="hoverIndex === 5 && showMask">
      <div class="user-login" @mouseleave="showMask = false">
        <div class="user-login-wrap">
          <div class="img-wrap">
            <img src="@/assets/img/jx-mini.jpg" />
            <span> 扫一扫登录</span>
          </div>
        </div>
      </div>
    </div>
    <div class="user-mask" v-if="showMenu">
      <ul class="user-login col-around-start column-nav">
        <li v-for="(item, index) in navList2" :key="index" :class="index == navIndex ? 'active' : 'noactive'"
          @click="navClick(index, item.name)">
          <div class="goAddress" @click="goPath(item)" @mouseover="mouseOver(item)" @mouseleave="mouseLeave"
            :class="menuIndex == item.path ? 'goAddress-active' : ''">
            {{ item.name }}
            <span v-if="item.children.length > 0" class="glyphicon glyphicon-menu-down"></span>
            <i class="underline"></i>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import API from "../api/index";
import dataJson from '../assets/data.json'
export default {
  name: "Header",
  data() {
    return {
      headerFixed: false,
      menuIndex: "/",
      hoverIndex: 0,
      dataJson: dataJson,
      productsAndServices: dataJson.productsAndServices,
      solution: dataJson.solution,
      applicationCases: dataJson.applicationCases,
      tabsValue1: '1',
      tabsValue2: '1',
      showMask: false,
      showMenu: false,
      isShowLogin: false,
      imageName: '@/assets/img/sk',
      navList: [
        {
          name: "首页",
          path: "/",
          children: [],
        },
        // {
        //   name: "产品与服务",
        //   path: "/productsAndServices",
        //   children: [],
        // },
        // {
        //   name: "解决方案",
        //   path: "/solution",
        //   children: [],
        // },
        // {
        //   name: "应用案例",
        //   path: "/applicationCases",
        //   children: [],
        // },
        {
          name: "关于我们",
          path: "/aboutUs",
          children: [],
        },
        // {
        //   name: "下载中心",
        //   path: "/download",
        //   children: [],
        // },
        {
          name: "智联灵犀Ai",
          path: "/DeepSeek",
          children: [],
        },
        {
          name: "工厂登录",
          path: "/workShopLogin",
          address: "https://juxiangshare.com/workshop/login",
          children: [],
        },
        {
          name: "用户登录",
          path: "/userLogin",
          address: "https://juxiangshare.com/workshop/login",
          children: [],
        },
      ],
      navList2: [
        {
          name: "首页",
          path: "/",
          children: [],
        },
        {
          name: "关于我们",
          path: "/aboutUs",
          children: [],
        },
        {
          name: "下载中心",
          path: "/download",
          children: [],
        },
        {
          name: "用户登录",
          path: "/userLogin",
          address: "https://juxiangshare.com/workshop/login",
          children: [],
        },
      ],
      navIndex: sessionStorage.getItem("navIndex")
        ? sessionStorage.getItem("navIndex")
        : 0,
    };
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    // 组件销毁前移除事件监听器
    window.removeEventListener('scroll', this.handleScroll);
  },
  watch: {
    $route(to, from) {
      // console.log(from.path,208,to.path);//从哪来

      if (to.path == '/aboutUs') {
        this.menuIndex = '/aboutUs'
        // console.log(' this.menuIndex', this.menuIndex)
      } else if (to.path == '/productsAndServices') {
        this.menuIndex = '/productsAndServices'
      } else if (to.path == '/solution') {
        this.menuIndex = '/solution'
      } else if (to.path == '/applicationCases') {
        this.menuIndex = '/applicationCases'
      } else if (to.path == '/' || to.path == '/home') {
        this.menuIndex = '/'
      }
    }
  },
  methods: {
    handleScroll() {
      // console.log(window.scrollY); // 输出当前滚动位置
      if (window.scrollY > 0) {
        this.headerFixed = true;
        this.showMask = false;
      } else {
        this.headerFixed = false;
      }
    },
    getImagePath(e) {
      // console.log(198, e);
      return require("../assets/img/sk/" + e);
    },
    //跳转产品与服务详情页
    goProductsServices(e, index) {
      this.showMask = false;
      this.menuIndex = '/productsAndServices';
      this.$router.push({ path: '/productsAndServices', query: { id: e.id } });
    },
    //跳转解决方案页面
    goSolution(e, index) {
      this.showMask = false;
      this.menuIndex = '/solution';
      this.$router.push({ path: '/solution', query: { id: e.id } });
    },
    //跳转应用案例页
    goApplicationCase(e, index) {
      this.showMask = false;
      this.menuIndex = '/applicationCases';
      this.$router.push({ path: '/applicationCases', query: { id: e.id } });
    },
    showHiddenMenu() {
      console.log('显示导航栏')
      this.showMenu = true;
    },
    navClick(index, name) {
      const params = {
        state: 1 || "",
      };
      API.lunbo.getLunBoList(params).then((res) => {
        if (res.code === 200) {
          console.log("res", res);
          this.imgList = res.data.list;
        }
      });
      this.navIndex = index;
      sessionStorage.setItem("navIndex", index);
      this.menuName = name;
      this.showMenu = false;

    },
    // 路由跳转
    goPath(item) {
      console.log("item", item);
      if (item.path == '/productsAndServices') {
        return
      }
      if (item.path == '/solution') {
        return
      }
      if (item.path == '/applicationCases') {
        return
      }
      if (item.path == '/workShopLogin') {
        window.open(item.address, "_blank");
        return
      }
      if (item.path == '/userLogin') {
        return
      }
      this.menuIndex = item.path;

      if (this.$route.path == this.menuIndex) {
        return;
      }
      this.$router.push({ path: item.path });
    },
    // 连接跳转
    goHref(path) {
      window.open(path, "_blank");
    },
    goHome() {
      console.log(this.$route.path);
      if (this.$route.path == "/home" || this.$route.path == "/") {
        return;
      }
      this.$router.push({ path: "/" });
    },

    mouseOverNav(index) {
      this.hoverIndex = index + 1;
      if (this.hoverIndex === 2) {
        this.tabsValue1 = '0'
      } else if (this.hoverIndex === 3) {
        this.tabsValue2 = '0'
      }
      if(this.hoverIndex===5){
        this.showMask = true;
      }
      // console.log(item)
      // if (item.path == '/userLogin') {
      //   this.isShowLogin = true
      // } else {
      //   this.isShowLogin = false
      // }
    },
    // 移出
    mouseLeave() {
      this.tabsValue = '1';
      // this.hoverIndex = 0;
      // this.isShowLogin = false
    }
  },
};
</script>
<style>
.el-tabs--left {
  width: 100%;
}

.is-left {
  width: 200px !important;
  text-align: left;
}

.el-tabs__active-bar {
  background-color: #409EFF00 !important;
}

.el-tabs__content {
  width: calc(100% - 310px) !important;
}
</style>
<style scoped>
.fixed {
  position: fixed !important;
}

.tab3-image {
  width: 20px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-right: 10px;
}

.row-end-center {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.tab-pane-left {
  font-size: 16px;
}

.tab-pane-right-title {
  font-size: 16px;
  font-weight: 600;
}

.tab-image {
  width: 20px;
  height: 20px;
  display: inline;
  margin-right: 5px;
}

.row-start-start-flex {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: wrap;
}

.row-center-center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.ellipes-line-clamp3 {
  overflow: hidden;
  display: -webkit-box;
  overflow-wrap: break-word;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3
}

.head {
  /* padding:0 360px 0 360px; */
  /* position: relative; */
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 0 10px 0 10px;
  position: fixed;
  top: 0;
  width: 100%;
  height: 80px;
  z-index: 999;
  background-color: #ffffff;
  border-bottom: 1px solid #e5e5e5;
}

.header {
  padding: 0px 20px;
  position: relative;
  background-color: #ffffff;
  left: 0%;
  right: 0;
  z-index: 101;
  min-width: 1263px;
}

.head_wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  top: 0;
  /* width: 64%; */
  /* width: 1200px; */
  height: 78px;
  z-index: 999;
  background-color: #ffffff;
}

.header .left {
  margin-right: 20px
}

.head .left img {
  width: 138px;
  height: 57px;
}

.head .left span {
  font-size: 25px;
  color: rgba(51, 51, 51, 1);
  /* font-weight: 600; */
  font-family: PingFangSC-Medium, PingFang SC;
  margin-left: 10px;
}

.menu_list {
  display: flex;
}

.menu_list .menu_item {
  margin-left: 20px;
  font-size: 20px;
  color: rgba(51, 51, 51, 1);
  /* font-weight: 600; */
  font-family: PingFangSC-Medium, PingFang SC;
}

/* 导航栏 导航容器 */
.menu_list .-nav-wrapper {
  line-height: 50px;
}

.menu_list .-nav-wrapper {
  /* line-height: 110px; */
  float: right;
  margin: 0;
  /* max-width: 800px; */

}



.menu_list .-nav-wrapper>li:last-child {
  margin: 0 0 0 15px;
}

/* 导航栏 每个导航下面的 a 链接 */
.menu_list .-nav-wrapper>li>a {
  color: #333;
  font-size: 15px;
  font-weight: bold;
  padding: 15px 0;
  position: relative;
}

/* 导航栏 每个导航下面的 a 链接的下划线 */
.menu_list .-nav-wrapper>li>a>i {
  display: block;
  position: absolute;
  bottom: -2px;
  left: 50%;
  width: 0;
  height: 2px;
  opacity: 0;
  transition: all 0.6s ease;
  background-color: #ff5400;
}

/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
.menu_list .-nav-wrapper>li>a>span {
  font-size: 12px;
  transition: transform ease 0.5s;
}

/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
.menu_list .-nav-wrapper>li>a:hover {
  color: #ff5400;
  text-decoration: none;
}

/* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
.menu_list .-nav-wrapper>li>a:hover .underline {
  opacity: 1;
  width: 100%;
  left: 0;
}

/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
.menu_list .-nav-wrapper>li>a:hover span {
  transform: rotate(180deg);
}

/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
.menu_list .-nav-wrapper>li.active>a {
  color: #ff5400;
  text-decoration: none;
  border-bottom: 2px solid #ff5400;
}

/* 导航栏 每个导航下面的二级导航容器 */
.menu_list .-nav-wrapper>li>dl {
  display: none;
  position: absolute;
  width: 168px;
  top: 80%;
  left: 0;
  z-index: 999999;
  box-shadow: 0 0 3px 1px #ccc;
  background: #fff;
}

/* 导航栏 每个导航下面的二级导航容器的每个导航 */
.menu_list .-nav-wrapper>li>dl>dt {
  width: 100%;
  padding: 10px;
  border-bottom: 1px solid #ccc;
}

/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
.menu_list .-nav-wrapper>li>dl>dt>a:hover {
  text-decoration: none;
}

/* 导航栏 滑上一级导航显示二级导航 */
.menu_list .-nav-wrapper>li:hover dl {
  display: block;
}

.menu_list .-nav-wrapper>li>dl>dt:hover {
  cursor: pointer;
  background: #ccc;
  color: #ff5400;
}

.goAddress {
  color: #333;
  font-size: 14px;
  font-weight: bold;
}

.goAddress:hover {
  color: #ff5400;
  text-decoration: none;
  height: 49px;
  cursor: pointer;
}

.goAddress-active {
  color: #ff5400;
  text-decoration: none;
  height: 49px;
  border-bottom: 2px solid #ff5400;
  cursor: pointer;
}

.user-mask {
  position: fixed;
  z-index: 11;
  top: 97px;
  left: 0;
  background: rgba(0, 0, 0, 0.3);
  width: 100%;
  height: 100%;

}

.user-login {
  z-index: 2;
  background: #ffffff;
  width: 100%;
  /* left: 1%;
  right: 1%; */
  /* height: 180px; */
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  padding: 20px 0;
  /* background-image: url('../assets/img/sk/productBg.08782bd.png'); */
  /* top: 50px; */
}

.user-login-box {
  width: 1200px;
  margin: 0 auto;
}

.user-login-wrap {
  width: 1200px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.img-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.img-wrap span {
  margin-top: 10px;
  font-size: 13px;
  color: #aaaaaa;
}

.user-login img {
  width: 100px;
  height: 100px;
}

@media screen and (min-width: 600) and (max-width: 1200px) {
  .head_wrap {
    width: 100%;
    padding: 0 10px;
  }

  /* .-nav-wrapper{
    width: 300px;
  } */
  .goAddress {
    font-size: 13px;
  }

  .menu_list .-nav-wrapper>li {
    margin: 0 10px;

  }

  .head .left img {
    width: 69px;
    height: 29px;
  }

  .head .left span {
    font-size: 14px;

  }

  .user-login-wrap {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

@media screen and (min-width: 0) and (max-width: 599px) {
  .head_wrap {
    width: 100%;
    padding: 0 10px;
  }

  .-nav-wrapper {
    width: 300px;
  }

  .goAddress {
    font-size: 13px;
  }

  .menu_list .-nav-wrapper>li {
    margin: 0 10px;

  }

  .head .left img {
    width: 69px;
    height: 29px;
  }

  .head .left span {
    font-size: 14px;

  }

  .user-login-wrap {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.zhedie-box {
  /* width: 40px;height: 40px;
  background-color: #ff5400;
  border-radius: 8px;
  text-align: center; */
}

.column-nav .goAddress-active {
  border-bottom: none;
}

.column-nav li {
  height: 50px;
  line-height: 50px;
}

.column-nav li .goAddress {
  font-size: 13px;
  font-weight: normal;
}

@media (max-width: 768px) {
  .header {
    /* margin: 0 5px; */
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 15px;
    padding-right: 15px;
  }

  .left img {
    width: 100px;
  }

  .zhedie-box {
    display: block;
  }

  .menu_list {
    display: none;
  }

  .user-mask {
    top: 61.3px;
  }
}

@media screen and (min-width: 768px) and (max-width: 991px) {
  .zhedie-box {
    display: none;
  }

  .menu_list .-nav-wrapper>li {
    float: left;
    margin: 0 10px;
    position: relative;
  }
}

@media screen and (min-width: 992px) and (max-width: 1199px) {
  .zhedie-box {
    display: none;
  }

  .menu_list .-nav-wrapper>li {
    float: left;
    margin: 0 29px;
    position: relative;
  }
}

@media (min-width: 1200px) {
  .zhedie-box {
    display: none;
  }

  .menu_list .-nav-wrapper>li {
    float: left;
    margin: 0 29px;
    position: relative;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue